import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../../config/api';
import {
  addSources,
} from '../../../features/createBudget/createBudgetSlice';

export const useSources = () => {
  const dispatch = useDispatch();

  const { sources } = useSelector(state => state.createBudget);

  useEffect(() => {
    const fetchSources = async () => {
      if (sources.length === 0) {
        try {
          const res = await api.GET_DATA_SOURCES();
          if (res.status === 'OK') {
            dispatch(addSources(res));
          }
        } catch (error) {
          console.error('Error fetching data sources:', error);
        }
      }
    };

    fetchSources();

  }, [sources.length, dispatch]);

  return {
    sources,
  };
};
